import { TypeSortie } from "./type-sortie";


export class PatientAttente {
  id: number;
  prenom: string;
  nom: string;
  sexe: string;
  civilite: string;
  tel1: string;
  codepatient: string;
  datenaissance: any;
  lieunaissance: string;
  cni: string;
  numeroOrdre: number;
  tel2: string;
  adresse: string;
  nomFichier: string;
  dateCreation: any;
  dateRecu: any;
  heureRecu: any;

  contactPrenom: string;
  contactNom: string;
  contactSexe: string;
  contactTel: string;
  contactLien: string;

  actif: boolean;
  dateSortie:any;
  descriptionSortie: string;
  typeSortie: TypeSortie;

  idPatient: number;


  public toString(): string {
    return ` ${this.prenom} ${this.nom}`;
  }

}

export class PatientAttenteExport {
  Numero: string;
  Prenom: string;
  Nom: string;
  DateNaissance: string;
  Telephone1: string;
  Telephone2: string;
  Adresse: string;
  Date_Recu: string;
}


export class Data {
  imprimeLe: string;
  dateRecu: string;
  LieuRecu: string;
  heureRecu: string;
  cni: string;
  prenom: string;
  nom: string;
  sexe: string;
  dateNais: string;
  lieuNais: string;
  adresse: string;
  telUn: string;
  telDeux: string;
  contactNom: string;
  contactPrenom: string;
  contactLien: string;
  contactTel: string;
}


export class recepiceAttente {
  template: string;
  extension: string;
  nomFichier: string;
  parameters: string;
  useInternalFolder: boolean;
  data: Data;
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/patient-attente.ts